import { ThemeUICSSObject, responsive, spacing } from '@apia/theme';

export const breakHeadings = 3;
export const hamburguerMenu = 3;

const topBox: ThemeUICSSObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: spacing(3),

  '.topBox__upperAside': {
    '.notificationsView': {
      display: 'flex',
      gap: spacing(3),
      flexDirection: 'column',

      '.notification': {
        m: spacing(0),

        '&:first-of-type': {
          mt: spacing(3),
        },
      },
    },
  },

  '.topBox__heading': {
    flexGrow: 1,
    display: 'flex',
    gap: spacing(3),
    flexDirection: 'row',
    alignItems: 'center',

    '.topBox__imageHeader': {
      flexShrink: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      img: {
        display: responsive({ 0: 'none', 3: 'inline-block' }),
        width: '70px',
        height: '70px',
      },
    },

    '.topBox__header': {
      flexGrow: 1,
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',

      '.topBox__headings': {
        display: 'flex',
        alignItems: responsive({ 0: 'start', 3: 'end' }),
        flexWrap: 'wrap',
        gap: spacing(3),
        flexDirection: responsive({ 0: 'column', [breakHeadings]: 'row' }),
        justifyContent: responsive({
          0: 'start',
          [breakHeadings]: 'initial',
        }),

        '& > *': {
          m: spacing(0),
        },

        h2: {
          '&:before': {
            content: '"-"',
            display: responsive({
              0: 'none',
              [breakHeadings]: 'inline-block',
            }),
          },
        },
      },

      p: {
        textAlign: responsive({ 0: 'center', [breakHeadings]: 'left' }),
        display: responsive({ 0: 'none', 3: 'block' }),
      },
    },

    '.topBox__nav': {
      flexShrink: 0,
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',

      '.HamburguerIconWrapper': {
        '&:not(.forced)': {
          display: responsive({ 0: 'none', 3: 'flex', 4: 'none' }),
        },
        width: '41px',
      },

      'button, a': {
        height: '40px',
        width: '40px',
        px: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'none',
        color: 'palette.secondary.main',
        border: 'none',

        svg: {
          width: '25px',
          height: '25px',
          path: { fill: 'palette.secondary.main' },
        },

        '&.favorite': {
          color: 'favorite',
          path: { fill: 'favorite' },
        },
      },
    },
  },
};

export default topBox;
